import React, { createRef } from "react";
import { bool, func } from "prop-types";
import Checkbox from "../../../common/Checkbox/index";

const Declaration = ({ hasConsented, setField }) => {
  const acknowldgementInput = createRef();

  return (
    <div>
      <p>
        I consent that I have answered all questions correctly and honestly and
        I understand that failure to disclose the relevant information may
        result in termination of my assignment.
      </p>
      <p>
        I have read the Privacy Policy and understand that my personal data will
        be forwarded to employers and third parties in order for you to obtain
        references, in order to provide me with work, payroll services and to
        comply with any internal and external audit requirements.
      </p>
      <p>
        I also consent to HRGO Recruitment checking my DBS status online and
        manually, carrying out a DBS check where relevant, obtaining the result
        electronically and for HRGO to receive the DBS certificate directly.
      </p>
      <p>
        I agree that HRGO Recruitment will deduct monies from my pay to recover
        any accidental overpayment.
      </p>
      <p>
        I am aware the HRGO Recruitment Temporary Worker’s Handbook is available
        online and that it is my responsibility to adhere to the policies it
        contains, including timesheet deadlines.
      </p>
      <p>
        I understand that I must treat all information relating to any clients
        or HRGO as confidential and that failure to do so may be in breach of
        GDPR 2018 and my contract, and could result in the termination of my
        assignment.
      </p>
      <p>
        I will seek advice from my consultant if there is anything I do not
        understand.
      </p>
      <div className="mt-3">
        <Checkbox
          label={`I confirm the above statement*`}
          ref={acknowldgementInput}
          isChecked={hasConsented}
          name="consent"
          onClick={() => {
            setField("generalConsent", acknowldgementInput.current.checked);
          }}
        />
      </div>
    </div>
  );
};

Declaration.propTypes = {
  hasConsented: bool.isRequired,
  setField: func.isRequired,
};

Declaration.defaultProps = {
  hasConsented: false,
};

export default Declaration;
